var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElionSwitch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "elionSwitch",
    "data-name": "Elion Switch",
    width: "100%",
    height: "100%",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -32 143.81 154.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "rgb(255, 26, 61)",
    className: "cls-1",
    cx: 95.44,
    cy: 45.74,
    r: 14.32
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255, 26, 61)",
    className: "cls-1",
    d: "M99.47,89.61h-55.09C20.18,89.61.5,69.93.5,45.74S20.18,1.86,44.38,1.86h55.09c24.19,0,43.88,19.68,43.88,43.88s-19.68,43.88-43.88,43.88ZM44.38,25.72c-11.04,0-20.02,8.98-20.02,20.02s8.98,20.02,20.02,20.02h55.09c11.04,0,20.02-8.98,20.02-20.02s-8.98-20.02-20.02-20.02h-55.09Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElionSwitch);
export default __webpack_public_path__ + "static/media/elionSwitch.121dbe2277c643605d8168ee1e119e70.svg";
export { ForwardRef as ReactComponent };